import Arrow from "../../img/arrow_selector.svg";
import { saveToLocalStorage } from "@utils";
import { inject, observer } from "mobx-react";
import { useEffect, useState } from "react";

import "./style.scss";

const fallbackGeoId = "fallbackGeoOption";

const regionDefault = {
    name_with_type: "Моего региона нет в списке",
    _id: fallbackGeoId,
};

const cityDefault = {
    city: "Моего города нет в списке",
    _id: fallbackGeoId,
};

const metroDefault = {
    name: "Моего метро нет в списке",
    _id: fallbackGeoId,
};

const MOSCOW_SPB_IDS = ["664746e41feb2258b05f5e68", "664746e41feb2258b05f5e69"];

const defaultRegion = {
    name_with_type: "Регион не выбран",
};

const AB_3156 = inject("mainStore")(
    observer(({ mainStore, limit, item, formTemplateAnswerState, handleClickExit, promo, setStateAnswer }) => {
        const data = mainStore.getMainStore("locationData");
        const cityMainStore = mainStore.getMainStore("citiesData");
        const metroMainStore = mainStore.getMainStore("metroData");
        const userLocation = mainStore.getMainStore("userLocation");
        const [isUseGeo, setIsUseGeo] = useState("region");
        const [open, setOpen] = useState(false);
        const [checked, setChecked] = useState(false);
        const [search, setSearch] = useState("");
        const [dataFilter, setDataFilter] = useState(false);
        const [dataFilterCity, setDataFilterCity] = useState([]);
        const [dataFilterMetro, setDataFilterMetro] = useState([]);

        const { regionIds, cityIds, metroStationIds } = extractGeoArrays(promo?.geoObject);
        const dataRegionPromo = data ? data.filter((it) => regionIds?.includes(it._id)) : [];
        const dataCityPromo = cityMainStore && cityMainStore.length > 0 ? cityMainStore.filter((el) => cityIds?.includes(el._id)) : [];
        const dataMetroPromo = metroMainStore && metroMainStore.length > 0 ? (metroStationIds ? metroMainStore.filter((el) => metroStationIds.includes(el._id)) : []) : [];
        const localStorageUser = localStorage.getItem("locale_ris_promo")
            ? JSON.parse(localStorage.getItem("locale_ris_promo"))
            : userLocation && userLocation._gtip && userLocation._gtip.data && userLocation._gtip.data.region
              ? userLocation._gtip?.data?.region
              : defaultRegion;
        const hasSelectedRegion = Boolean(userLocation?.regionId || localStorageUser?._id);

        useEffect(() => {
            setIsUseGeo(item.typeQuestions);

            if (localStorage.getItem("selectRegion")) {
                let reg = JSON.parse(localStorage.getItem("selectRegion"));

                setDataFilterCity(dataCityPromo ? dataCityPromo.filter((el) => cityIds.includes(el._id) && el.regionId === reg._id) : []);
            } else {
                setDataFilterCity(dataCityPromo ? dataCityPromo.filter((el) => cityIds.includes(el._id)) : []);
            }
        }, [item]);

        useEffect(() => {
            if (isUseGeo === "city") {
                if (search.length > 1) {
                    setDataFilterCity(dataFilterCity.filter((it) => it.city.toLowerCase().includes(search.toLowerCase())));
                } else {
                    const idRegion = mainStore.getMainStore("promoIdRegion");

                    if (idRegion) {
                        const city = dataCityPromo ? dataCityPromo.filter((el) => el.regionId === idRegion) : [];
                        if (city.length) {
                            setDataFilterCity(dataCityPromo ? dataCityPromo.filter((el) => el.regionId === idRegion) : []);
                        } else {
                            setIsUseGeo("metro");
                            setStateAnswer(2);
                        }
                    } else {
                        setDataFilterCity(dataCityPromo);
                    }
                }
            }

            if (isUseGeo === "metro") {
                if (search.length > 1) {
                    setDataFilterMetro(dataFilterMetro.filter((it) => it.name.toLowerCase().includes(search.toLowerCase())));
                } else {
                    const idCity = mainStore.getMainStore("promoIdCity");
                    const idRegion = mainStore.getMainStore("promoIdRegion");

                    if (idCity) {
                        const metro = dataMetroPromo ? dataMetroPromo.filter((it) => it.parentId === idCity || it.parentId === idRegion) : [];

                        if (metro && metro.length) {
                            setDataFilterMetro(metro);
                        } else {
                            setStateAnswer(6);
                        }
                    } else {
                        if (!idRegion) {
                            setDataFilterMetro(dataMetroPromo ? dataMetroPromo : []);
                        } else {
                            setDataFilterMetro(dataMetroPromo ? dataMetroPromo.filter((it) => it.parentId === idRegion) : []);
                        }
                    }
                }
            }
        }, [isUseGeo, search]);

        useEffect(() => {
            if (search.length > 1) {
                setDataFilter(dataRegionPromo.filter((it) => it.name_with_type.toLowerCase().includes(search.toLowerCase())));
            } else {
                setDataFilter(dataRegionPromo.concat(regionDefault));
            }
        }, [search]);

        useEffect(() => {
            if (open) {
                setDataFilter(dataRegionPromo.concat(regionDefault));
                setSearch("");
            }
        }, [open]);

        const handleChecked = (value) => {
            setChecked(value);
            setOpen(false);
        };

        const updateUserRegion = (regionId) => {
            if (hasSelectedRegion) {
                return;
            } else {
                mainStore.setMainStore("userLocation", {
                    ...userLocation,
                    regionId,
                });
            }
        };

        const handleUpdateLocation = async (value) => {
            if (hasSelectedRegion) {
                return;
            } else {
                if (value === regionDefault._id || value?._id === regionDefault._id) return;

                const regionId = value.regionId || value.parentId || value._id;
                const selectRegion = data?.find((region) => region._id === regionId);

                const inData = {
                    regionId,
                    cityId: regionId !== value._id ? value._id : "",
                };

                if (selectRegion) {
                    saveToLocalStorage("locale_ris_promo", selectRegion);
                }

                await mainStore.getByUrl("/app_rispromo_user/update_location", inData, false, "", false);
            }
        };

        const handleCitySelect = (el) => {
            mainStore.setMainStore("promoIdCity", el._id);
            updateUserRegion(el.regionId);
            const selectCity = JSON.parse(localStorage.getItem("selectCity"));

            if (selectCity?._id === el._id) return;

            handleUpdateLocation(el);
            saveToLocalStorage("selectCity", el);
        };

        const handleMetroSelect = (el) => {
            mainStore.setMainStore("promoIdMetro", el._id);

            if (el.parentType === "region") {
                updateUserRegion(el.parentId);
                const localeRisPromo = JSON.parse(localStorage.getItem("locale_ris_promo"));

                if (localeRisPromo?._id === el.parentId) return;
                handleUpdateLocation({ ...el, _id: null });

                return;
            }

            if (el.parentType === "city") {
                const parentCity = cityMainStore?.find((city) => city._id === el.parentId);

                if (!parentCity) return;

                handleUpdateLocation(parentCity);
                updateUserRegion(parentCity.regionId);
            }
        };

        const handleRegionSelect = (el) => {
            let location = null;
            saveToLocalStorage("selectRegion", el);
            mainStore.setMainStore("promoIdRegion", el._id);

            const localeRisPromo = JSON.parse(localStorage.getItem("locale_ris_promo"));

            if (localeRisPromo?._id === el._id) return;

            if (MOSCOW_SPB_IDS.includes(el._id) && el.cities?.[0]) {
                saveToLocalStorage("selectCity", el); // зачем этот ключ??
                location = el.cities[0];
            } else {
                location = el;
            }
            handleUpdateLocation(location);
            updateUserRegion(el._id);
        };

        const handleClick = (el) => {
            const type = item.typeQuestions;

            if (!type || type === "region") {
                handleRegionSelect(el);
                formTemplateAnswerState(el, "geo", item);
                return;
            }

            setChecked(false);
            setIsUseGeo(type);

            if (type === "city") {
                handleCitySelect(el);
            }

            if (type === "metro") {
                handleMetroSelect(el);
            }

            formTemplateAnswerState(el, "geo", item);
        };

        return (
            <div className="ab-3156 inherit__geo">
                <div className="title">{!limit ? item.question : item.restrictedMessage ? item.restrictedMessage : limit ? `${limit.isLimitText}` : `'К сожалению, вы не можете воспользоваться данным предложением.'`}</div>
                {!limit ? (
                    <div className={`inherit__geo_answers select`}>
                        <div className={`select `} onClick={() => setOpen(!open)}>
                            {checked ? (
                                <div className="multi__el" onClick={() => setOpen(!open)}>
                                    <span>{isUseGeo === "city" ? checked.city : isUseGeo === "metro" ? checked.name : checked.name_with_type}</span>
                                </div>
                            ) : (
                                <div className="select__block" onClick={() => setOpen(!open)}>
                                    <span className="select__title">{isUseGeo === "city" ? "Выберите город" : isUseGeo === "region" ? "Выберите регион" : "Выберите метро"}</span>
                                    <img src={Arrow} />
                                </div>
                            )}
                        </div>
                        <div className={`select__list-wrapper ${open ? "select__list-wrapper_open" : ""}`}>
                            <div className="select__list-content">
                                <div className="select__list_search">
                                    <form className="search__block">
                                        <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder={isUseGeo === "city" ? "Выберите город" : isUseGeo === "region" ? "Выберите регион" : "Выберите метро"} autoComplete="off" />
                                    </form>
                                </div>

                                <div className="select__list">
                                    {open ? (
                                        <>
                                            {(isUseGeo === "city" ? sortAlphabet(dataFilterCity, "city").concat(cityDefault) : isUseGeo === "metro" ? sortAlphabet(dataFilterMetro, "name").concat(metroDefault) : dataFilter).map((el, index) => (
                                                <div className={`select__list_item ${el._id === fallbackGeoId ? "select__list_item_last" : ""}`} key={index}>
                                                    <span onClick={() => handleChecked(el)}>{isUseGeo === "city" ? el.city : isUseGeo === "metro" ? el.name : el.name_with_type}</span>
                                                </div>
                                            ))}

                                            {(isUseGeo === "region" && dataFilter.length === 0) || (isUseGeo === "city" && dataFilterCity.length === 0) || (isUseGeo === "metro" && dataFilterMetro.length === 0) ? (
                                                <div className="select__list_item select__list_item_no-cursor">
                                                    <span>Не найдено</span>
                                                </div>
                                            ) : null}
                                        </>
                                    ) : null}
                                </div>
                            </div>
                        </div>

                        {checked ? (
                            <div className={`inherit__geo_button`} onClick={() => handleClick(checked)}>
                                Выбрать
                            </div>
                        ) : null}
                    </div>
                ) : (
                    <div className={`selecting__options_button`} onClick={() => handleClickExit()}>
                        {!limit ? "Вернуться назад" : `${limit.isLimitButtonText}`}
                    </div>
                )}
            </div>
        );
    }),
);

const sortAlphabet = (arr, key) => {
    return arr.reduce((sorted, item) => {
        const insertIndex = sorted.findIndex((sortedItem) => item[key].toLowerCase() < sortedItem[key].toLowerCase());

        if (insertIndex === -1) return [...sorted, item];

        return [...sorted.slice(0, insertIndex), item, ...sorted.slice(insertIndex)];
    }, []);
};

const extractGeoArrays = (geoObject = {}) => {
    const regionIds = [];
    const cityIds = [];
    const metroStationIds = [];

    for (const regionId in geoObject) {
        if (!Object.hasOwn(geoObject, regionId)) continue;
        regionIds.push(regionId);

        const regionContent = geoObject[regionId];

        // Обработка городов
        if (regionContent.cities && typeof regionContent.cities === "object") {
            for (const cityId in regionContent.cities) {
                if (Object.hasOwn(regionContent.cities, cityId)) {
                    cityIds.push(cityId);
                }

                const cityContent = regionContent.cities[cityId];

                if (cityContent?.metroStations && typeof cityContent?.metroStations === "object") {
                    for (const metroId in cityContent.metroStations) {
                        if (Object.hasOwn(cityContent.metroStations, metroId)) {
                            metroStationIds.push(metroId);
                        }
                    }
                }
            }
        }

        // Обработка станций метро
        if (regionContent.metroStations && typeof regionContent.metroStations === "object") {
            for (const metroId in regionContent.metroStations) {
                if (Object.hasOwn(regionContent.metroStations, metroId)) {
                    metroStationIds.push(metroId);
                }
            }
        }
    }

    return { regionIds, cityIds, metroStationIds };
};

export default AB_3156;
